import React, { useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Box from "@material-ui/core/Box";
import CurrencyPanel from "../../components/CurrencyPanel";
import StarIcon from "@material-ui/icons/Star";

import CurrencyList from "../CurrencyList";
import { BsFillLightningChargeFill } from "react-icons/bs";
import { Divider } from "@material-ui/core";
import { FaStar } from "react-icons/fa";

// for drawer tabs
function TabPanelDrawer(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      hidden={value !== index}
      id={`simple-tabpaneldrawer-${index}`}
      aria-labelledby={`simple-tabdrawer-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanelDrawer.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yPropsDrawer(index) {
  return {
    id: `simple-tabdrawer-${index}`,
    "aria-controls": `simple-tabpaneldrawer-${index}`,
  };
}

export default function CurrencyTabs(props) {
  const classes = useStyles();
  const theme = useTheme();
  const [valueDrawer, setValueDrawer] = useState(0);

  const handleChangeDrawer = (event, newValue) => {
    setValueDrawer(newValue);
  };

  return (
    <>
      <div className={classes.toolbar}>
        <Tabs
          value={valueDrawer}
          onChange={handleChangeDrawer}
          indicatorColor="primary"
          textColor="primary"
          classes={{
            root: classes.rootTabParent,
          }}
        >
          <Tab
            label="Markets"
            className="capitalize "
            classes={{ root: classes.rootTab }}
            {...a11yPropsDrawer(1)}
          />
          <Tab
            label="Innovation Zone"
            icon={<BsFillLightningChargeFill className="mr-1 text-[14px] " />}
            className="capitalize"
            {...a11yPropsDrawer(0)}
            classes={{
              root: classes.rootTab,
              wrapper: classes.wrapperTab,
              labelIcon: classes.labelIconTab,
            }}
          />{" "}
          <Tab
            icon={<StarIcon className=" " size="18px" />}
            className="uppercase"
            classes={{ root: classes.rootTabFav }}
            {...a11yPropsDrawer(0)}
          />
        </Tabs>
      </div>
      <Divider className="mb-2" />

      <TabPanelDrawer value={valueDrawer} index={0}>
        <CurrencyPanel tab="MARKETS" />
      </TabPanelDrawer>
      <TabPanelDrawer value={valueDrawer} index={1}>
        <CurrencyPanel tab="INNOVATION" />
      </TabPanelDrawer>
      <TabPanelDrawer value={valueDrawer} index={2}>
        <CurrencyPanel tab="FAV" />
      </TabPanelDrawer>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  rootTabParent: {
    minHeight: "45px",
    maxHeight: "45px",
    width: "100%",
    "& .Mui-selected": {
      fontWeight: "bolder",
      letterSpacing: "0px",
    },
  },
  rootTab: {
    fontSize: "13px",
    letterSpacing: "0.5px",
    padding: "0px 10px",
    height: "40px",
    // width: "10px",
    display: "flex",
    // fontWeight: "bold",
    alignItems: "center",
    minWidth: "calc((100% / 3))",
    whiteSpace: "nowrap", // a number of your choice
  },
  rootTabFav: {
    padding: "0px 10px",
    height: "40px",
    alignItems: "center",
    minWidth: "calc((100% / 3) - 20px)",
  },
  wrapperTab: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "4px",
  },
  labelIconTab: { minHeight: "45px" },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    // padding: theme.spacing(0, 1),
    // marginTop: '60px',
    // necessary for content to be below app bar
    // ...theme.mixins.toolbar,
    // backgroundColor: '#202333'
    // minWidth: "450px",
    minHeight: "48px",
  },
}));
